var _defs, _path, _path2, _path3, _path4, _rect, _polygon, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuerokrattLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2254.92 780",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B\xFCrokrati logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M935.55,340.58c-23.41,0-46.48,7.91-59,23.4V264.42h-27V515.64h27.7V491.25h3.95c7.25,18.13,30.33,27,50.12,27,47.14,0,84.4-35.94,84.4-91.65C1015.67,374.87,983,340.58,935.55,340.58Zm-8.9,154.62c-26,0-50.11-14.51-50.11-37.25V410.14c1-27,25.71-46.49,51.1-46.49,33.3,0,59.67,23.41,59.67,64.29C987.31,473.11,958.3,495.2,926.65,495.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1159.67,454.65c-1.65,24.07-31.65,39.56-51.1,39.56-28,0-48.46-14.83-48.46-43.19V343.87H1033.4V453.33c0,45.5,27,64.62,65.94,64.62,22.75,0,46.48-8.9,57-32.64H1161v30.33h25.39V343.87h-26.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1300,342.88h-23.73c-19.78,0-32.64,10.55-37.26,31.32h-4.62v-30H1206.7V515.64h28.69V416.08c2-28.69,20.43-49.46,40.88-49.46H1300Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1384.67,340.25c-51.76,0-86.71,35.93-86.71,90.33,0,54.07,34.29,89.68,86.71,89.68,53.41,0,87.37-35.28,87.37-90.67C1472,375.19,1436.76,340.25,1384.67,340.25Zm0,157.26c-31.65,0-58.68-25.72-58.68-66.93,0-44.18,27-67.91,58.68-67.91,33.63,0,59.34,23.73,59.34,67.91C1444,472.12,1418,497.51,1384.67,497.51Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1490.1,
    y: 264.42,
    width: 27.03,
    height: 251.22
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1632.53 352.44 1632.53 344.2 1606.49 344.2 1517.8 429.92 1604.51 515.64 1636.82 515.64 1636.82 507.4 1552.09 427.29 1632.53 352.44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1687.2,374.2h-4.62v-30h-27.69V515.64h28.69V416.08c2-28.69,20.43-49.46,40.88-49.46h23.73V342.88h-23.73C1704.68,342.88,1691.82,353.43,1687.2,374.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2051.14,285.19h-26.37l-.33,59h-66.59l.66-59h-26.38l-.33,59h-27V366h27l-.33,99.9c-.32,38.9,13.2,49.78,42.53,49.78h22.1V494.87H1979c-12.86,0-21.76-4.28-21.76-26.7l.66-102.21h66.59l-.33,99.9c-.33,38.9,13.19,49.78,42.53,49.78h22.09V494.87h-17.14c-12.87,0-21.77-4.28-21.77-26.7l.67-102.21h41.2V344.2h-41.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1824.34,340.91c-27.69,0-47.14,9.89-62,22.09v29.82a30.33,30.33,0,0,1,5-5.76c16.48-14.5,30.66-22.42,56.37-22.42,23.41,0,39.9,13.52,44.84,33.3l-2.64,4.29c-11.86,1.65-37.25,5.6-48.79,7.91-40.55,9.56-67.26,23.08-67.26,58.36,0,29.67,25.39,51.76,59.35,51.76,23.08,0,41.87-7.26,56.38-25.06h4.28v20.44h27c0-37.91.33-68.9.33-107.15C1897.2,367,1869.51,340.91,1824.34,340.91Zm45.5,121.65v-.66c0,23.41-31.32,34.62-49.45,34.62-25.39,0-42.86-9.56-42.86-28.35s14.17-28.36,48.13-34.62c8.91-1.65,30-4.95,44.51-7.25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.34,448.26a14,14,0,1,1,0-28C544.6,420.3,647,369.16,647,308.59a14,14,0,0,1,28,0C675,386.91,564.45,448.26,423.34,448.26Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661,322.58a14,14,0,0,1-14-14c0-61.73-98.79-112-220.24-112a14,14,0,1,1,0-28C566,168.66,675,230.12,675,308.59A14,14,0,0,1,661,322.58Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.67,364.38a14,14,0,0,1-14-14c0-101.9,112-181.74,255.09-181.74a14,14,0,1,1,0,28c-125.25,0-227.13,69-227.13,153.78A14,14,0,0,1,185.67,364.38Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.67,448.4a14,14,0,0,1-14-14c0-102,112.58-181.88,256.32-181.88a14,14,0,1,1,0,28c-125.91,0-228.36,69.05-228.36,153.92A14,14,0,0,1,185.67,448.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428,532.14c-141.33,0-256.32-81.53-256.32-181.74a14,14,0,0,1,28,0c0,83.36,104.58,153.78,228.36,153.78a14,14,0,1,1,0,28Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661,406.21a14,14,0,0,1-14-14c0-61.6-98.24-111.73-219-111.73a14,14,0,0,1,0-28c138.49,0,247,61.35,247,139.69A14,14,0,0,1,661,406.21Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.34,616c-138.77,0-251.65-81.53-251.65-181.74a14,14,0,0,1,28,0c0,84.78,100.35,153.78,223.69,153.78a14,14,0,0,1,0,28Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428,532.14a14,14,0,0,1,0-28c120.77,0,219-50.21,219-111.95a14,14,0,0,1,28,0C675,470.68,566.5,532.14,428,532.14Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.27,
    cy: 347.13,
    r: 15.73
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 456.18,
    cy: 347.13,
    r: 15.73
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1083.44,
    cy: 303.27,
    r: 15.73
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1136.34,
    cy: 303.27,
    r: 15.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuerokrattLogo);
export default __webpack_public_path__ + "static/media/buerokratt_logo.7ea781a225c5c7c60356067c2551f3b3.svg";
export { ForwardRef as ReactComponent };